import type { ConnectedGoogleAccount } from '@/api/custom';

export const DISCONNECTED_GOOGLE_ACCOUNT_LABEL = 'No calendar connected';

export const getGoogleCalendarAccountDisplayName = (
  account: Pick<ConnectedGoogleAccount, 'email'>,
) => account.email || DISCONNECTED_GOOGLE_ACCOUNT_LABEL;
